import React from 'react';
import { connect } from 'react-redux';
import ReactTable from 'react-table';
import 'react-table/react-table.css';
import { Button, IconButton } from '@material-ui/core';
import i18n from '../../../i18n/i18n';
import { toast } from 'react-toastify';
import ReactSelect from '../../../utils/ReactSelect';
import { getParcel, deleteParcel, setInitialState, setRowInReducer, getOwnershipDropDown } from '../../../actions/catastral_data/ParcelActions';
import AddParcel from './AddParcel';
// import { getFarmersDropdown } from '../../../actions/financial/IncentiveActions';
import { getLocalGov } from '../../../actions/DropDownActions';
import checkboxHOC from "react-table/lib/hoc/selectTable";
import immutable from 'seamless-immutable';
import { Delete } from '../../../utils/Delete';
import DialogTitle from '@material-ui/core/DialogTitle';
import { withStyles } from '@material-ui/core/styles';
const CheckboxTable = checkboxHOC(ReactTable);
const styles = theme => ({
});
export class ViewParcel extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            add: false,
            showFilters: false,
            selection: [],
            delete: false,
            selectAll: false,
            name: '',
            edit: false
        };
    }

    componentDidMount() {
        if (this.props.localGoverments.length === 0) {
            this.props.getLocalGov();
        }
        if (this.props.ownershipDropDown.length === 0) {
            this.props.getOwnershipDropDown();
        }
        // if (this.props.farmerDropdown.length === 0) {
        //     this.props.getFarmersDropdown();
        // }
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            parcel: nextProps.parcel,
            parcelFetching: nextProps.parcelFetching,
            // farmerDropdown: immutable.asMutable(nextProps.farmerDropdown.map((item) => { return { label: item.kontakt_osoba, value: item.id } }), { deep: true }),
            localGoverments: immutable.asMutable(nextProps.localGoverments.map((item) => { return { label: item.naziv, value: item.id } }), { deep: true }),
            ownershipDropDown: immutable.asMutable(nextProps.ownershipDropDown.map((item) => { return { label: item.naziv, value: item.id } }), { deep: true }),
        })
        if (nextProps.deleted === true) {
            const wrapped = this.checkboxTable.getWrappedInstance();
            this.props.getParcel(wrapped.state);
            this.setState({
                selection: [],
                selectAll: false,
                name: ''
            })
            this.props.setInitialState('parcelObj');
            this.props.setInitialState('deleted');
        }
        if (nextProps.parcelPostingSuccess === true) {
            this.handleClick();
            const wrapped = this.checkboxTable.getWrappedInstance();
            this.props.getParcel(wrapped.state);
            this.props.setInitialState('parcelPostingSuccess');
        }
        if (nextProps.deleteParcelFailed === true) {
            toast.error(i18n.t('This item can not be deleted!'), {
                position: "top-center",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                draggablePercent: 80
            });
            this.props.setInitialState('deleteParcelFailed');
        }

    }

    onSearchClick() {
        this.setState({ showFilters: !this.state.showFilters });
    }

    handleClick = () => {
        if (this.state.edit === true && this.state.add === false) {
            this.setState({ edit: false })
            this.props.setInitialState('parcelObj');
        } else if (this.state.selection.length > 0 && this.state.add === false && this.state.edit === false) {
            this.props.setInitialState('parcelObj');
        }
        this.setState({ add: !this.state.add }, () => {
            if (this.state.add === true && this.state.edit === false) {
                this.setState({
                    selection: [],
                    name: '',
                    selectAll: false,
                })
            }
        });
    };

    toggleSelection = (key, shift, row) => {
        let selection = [...this.state.selection];
        const keyIndex = selection.indexOf(key);
        if (keyIndex >= 0) {
            selection = [
                ...selection.slice(0, keyIndex),
                ...selection.slice(keyIndex + 1)
            ];
            this.props.setInitialState('parcelObj');
        } else {
            selection.push(key);
        }
        this.setState({ selection, name: 'parcel' }, function () {
            if (selection.length === 1) {
                let row1 = this.props.parcel.filter((parc) => {
                    return parc.id === selection[0];
                })
                this.props.setRowInReducer(row1[0]);
            }
        });
    };

    toggleAll = () => {
        const selectAll = this.state.selectAll ? false : true;
        const selection = [];
        if (selectAll) {
            const wrappedInstance = this.checkboxTable.getWrappedInstance();
            const currentRecords = wrappedInstance.getResolvedState().sortedData;
            currentRecords.forEach(item => {
                selection.push(item._original.id);
            });
        }
        this.setState({ selectAll, selection, name: 'parcel' });


    };

    isSelected = key => {
        return this.state.selection.includes(key);
    };

    onDeleteClick = () => {
        this.setState({ delete: !this.state.delete });
    }

    deleteItem = () => {
        this.props.deleteParcel(this.state.selection);
        this.setState({ delete: false })
    }

    onEditClick() {
        this.setState({ add: !this.state.add, edit: true });
    }



    render() {
        const { theme } = this.props;
        const columns = [
            {
                Header: i18n.t('Number'),
                accessor: 'broj'
            },
            {
                Header: i18n.t('Land area'),
                accessor: 'povrsina'
            },
            {
                Header: i18n.t('Ownership'),
                accessor: 'vlasnistvo',
                Filter: ({ filter, onChange }) =>
                    <ReactSelect
                        filter
                        isMulti
                        name="naziv"
                        onChange={value => {
                            onChange(value)
                        }}
                        closeMenuOnSelect={false}
                        options={this.state.ownershipDropDown}
                        className="multi-select-in-filter"
                        classNamePrefix="select"
                        placeholder={i18n.t('Select')}
                    />
            },
            // {
            //     Header: i18n.t('Crop'),
            //     accessor: 'naziv_kat_kulture',
            //     // Filter: ({ filter, onChange }) =>
            //     //     <Select
            //     //         isMulti
            //     //         name="naziv"
            //     //         onChange={value => {
            //     //             onChange(value)
            //     //         }}
            //     //         closeMenuOnSelect={false}
            //     //         options={this.state.crops}
            //     //         className="multi-select-in-filter"
            //     //         classNamePrefix="select"
            //     //     />
            // },
            {
                Header: i18n.t('Local government'),
                accessor: 'naziv_kat_opstine',
                Filter: ({ filter, onChange }) =>
                    <ReactSelect
                        filter
                        isMulti
                        name="naziv"
                        onChange={value => {
                            onChange(value)
                        }}
                        closeMenuOnSelect={false}
                        options={this.state.localGoverments}
                        className="multi-select-in-filter"
                        classNamePrefix="select"
                        placeholder={i18n.t('Select')}
                    />
            },
            {
                Header: i18n.t('Potes'),
                accessor: 'potes'
            },
            // {
            //     Header: i18n.t('Immovable property number'),
            //     accessor: 'br_lista'
            // },
            {
                Header: i18n.t('Class'),
                accessor: 'klasa'
            },

            // {
            //     Header: i18n.t('State area'),
            //     accessor: 'povrsina_drz'
            // },
            // {
            //     Header: i18n.t('Farmer'),
            //     accessor: 'klijent_naziv',
            //     Filter: ({ filter, onChange }) =>
            //         <ReactSelect
            //             filter
            //             isMulti
            //             name="naziv"
            //             onChange={value => {
            //                 onChange(value)
            //             }}
            //             closeMenuOnSelect={false}
            //             options={this.state.farmerDropdown}
            //             className="multi-select-in-filter"
            //             classNamePrefix="select"
            //             placeholder={i18n.t('Select')}
            //         />
            // },


        ];
        const { toggleSelection, toggleAll, isSelected } = this;
        const { selectAll } = this.state;
        const checkboxProps = {
            selectAll,
            isSelected,
            toggleSelection,
            toggleAll,
            selectType: "checkbox",
            getTrProps: (state, rowInfo, instance) => {
                if (rowInfo) {
                    const selected = this.isSelected(rowInfo.original.id);
                    return {
                        style: {
                            backgroundColor: selected ? "#acdaf1" : "inherit"
                        }
                    };
                }
                return {};
            },
            getTheadFilterProps: () => {
                return {
                    style: {
                        backgroundColor: theme.palette.primary.main
                    }
                };
            },
            getTheadTrProps: () => {
                return {
                    style: {
                        backgroundColor: theme.palette.secondary.main,
                        color: '#FFFFFF'
                    }
                };
            },
        };
        const filterOptions = {
            defaultFiltered:
                [
                    {
                        id: 'klijent_naziv',
                        value: this.props.klijent_naziv ? this.props.klijent_naziv : []
                    }
                ]
        };
        return (
            <div className="page">
                {this.props.isParcelShown ?
                    <div>
                        <DialogTitle disableTypography={true} style={{ background: theme.palette.secondary.dark }} className="responsive-dialog-title">{i18n.t('Parcels')}
                            <IconButton onClick={this.props.handleCloseParcel}>
                                <span className="icon-cancel-circle closeIcon" />
                            </IconButton>
                        </DialogTitle>
                    </div>
                    : null}
                <div className="table-header">
                    {!this.props.klijent_naziv ?
                        <Button
                            onClick={() => this.handleClick()}
                            variant="fab"
                            color="secondary"
                            aria-label="add"
                            className="action-button"
                        >
                            <span className="icon-Plus headerIcon" />
                        </Button> : null}
                    {!this.props.klijent_naziv ?
                        <Button
                            onClick={() => this.onSearchClick()}
                            variant="fab"
                            color="secondary"
                            aria-label="add"
                            className="action-button"
                        >
                            <span className="icon-search headerIcon" />
                        </Button> : null}
                    {this.state.selection.length > 0 ?
                        <Button
                            onClick={() => this.onDeleteClick()}
                            variant="fab"
                            color="secondary"
                            aria-label="add"
                            className="action-button"
                        >
                            <span className="icon-Kanta headerIcon" />
                        </Button>
                        : null
                    }
                    {this.state.selection.length === 1 ?
                        <Button
                            onClick={() => this.onEditClick()}
                            variant="fab"
                            color="secondary"
                            aria-label="edit"
                            className="action-button"
                        >
                            <span className="icon-Izmeni1 headerIcon" />
                        </Button>
                        : null
                    }
                </div>
                <CheckboxTable data={this.props.parcel}
                    ref={r => (this.checkboxTable = r)}
                    keyField={'id'}
                    getTheadFilterThProps={() => { return { style: { position: "inherit", overflow: "inherit" } } }}
                    columns={columns}
                    pageSizeOptions={[10, 25, 50, 100]}
                    defaultPageSize={25}
                    filterable={this.state.showFilters}
                    pages={this.props.parcelPages}
                    loading={this.props.parcelFetching}
                    manual
                    showPaginationTop
                    showPaginationBottom={false}
                    onFetchData={(state, instance) => this.props.getParcel(state, instance)}
                    className="-striped -highlight"
                    previousText={i18n.t('Previous')}
                    nextText={i18n.t('Next')}
                    loadingText={i18n.t('Loading...')}
                    noDataText={i18n.t('No rows found')}
                    pageText={i18n.t('Page')}
                    ofText={i18n.t('of')}
                    rowsText={i18n.t('rows')}
                    {...checkboxProps}
                    {...filterOptions}
                    PreviousComponent={(props) => (
                        <button {...props} className='-btn' style={{
                            backgroundColor: theme.palette.primary.main,
                            color: '#FFFFFF'
                        }}>{props.children}</button>
                    )}
                    NextComponent={(props) => (
                        <button {...props} className='-btn' style={{
                            backgroundColor: theme.palette.primary.main,
                            color: '#FFFFFF'
                        }}>{props.children}</button>
                    )}
                />
                {this.state.add && <AddParcel add={this.state.add} edit={this.state.edit}
                    handleClose={this.handleClick} />}
                {this.state.delete && <Delete delete={this.state.delete} handleClose={this.onDeleteClick} deleteItem={this.deleteItem} />}

            </div>

        )
    }


};

function mapStateToProps(state) {
    return {
        parcel: state.parcelReducer.parcel,
        parcelFetching: state.parcelReducer.parcelFetching,
        parcelPages: state.parcelReducer.parcelPages,
        deleted: state.parcelReducer.deleted,
        deleteParcelFailed: state.parcelReducer.deleteParcelFailed,
        parcelPostingSuccess: state.parcelReducer.parcelPostingSuccess,
        parcelObj: state.parcelReducer.parcelObj,
        localGoverments: state.appReducer.localGoverments,
        ownershipDropDown: state.parcelReducer.ownershipDropDown,
        // farmerDropdown: state.incentiveReducer.farmerDropdown,
    }
}

function mapDispatchToProps(dispatch) {
    return {
        getParcel: (state, instance) => dispatch(getParcel(state, instance)),
        deleteParcel: (selection, name) => dispatch(deleteParcel(selection, name)),
        setInitialState: (component) => dispatch(setInitialState(component)),
        setRowInReducer: (rowInfo) => dispatch(setRowInReducer(rowInfo)),
        getLocalGov: () => dispatch(getLocalGov()),
        getOwnershipDropDown: () => dispatch(getOwnershipDropDown()),
        // getFarmersDropdown: () => dispatch(getFarmersDropdown()),
    }
}

export default withStyles(styles, { withTheme: true })(connect(
    mapStateToProps,
    mapDispatchToProps
)(ViewParcel))